"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminSettingsController = /** @class */ (function () {
    function AdminSettingsController($rootScope, UserService, OnlineDriversEd) {
        var _this = this;
        this.user = UserService.getCurrentUser();
        this.ode_enabled = false;
        OnlineDriversEd.getFeatureDetails().then(function (response) {
            _this.ode_enabled = response.enabled;
        });
    }
    return AdminSettingsController;
}());
AdminSettingsController.$inject = [
    "$rootScope",
    "UserService",
    "OnlineDriversEd",
];
exports.default = AdminSettingsController;
